
const svg = '<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" role="img"><path fill-rule="evenodd" clip-rule="evenodd" d="M18.7071 8.70711L10.5 16.9142L6.29289 12.7071L7.70711 11.2929L10.5 14.0858L17.2929 7.29289L18.7071 8.70711Z" fill="currentColor"></path></svg>';export default svg;
    